var _desc, _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrumpet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M16 1C16 0.65 15.82 0.33 15.52 0.14C15.23 -0.04 14.86 -0.05 14.55 0.1L6.76 4L3 4C1.34 4 0 5.34 0 7C0 8.65 1.34 10 3 10L3.27 10L5.05 15.31C5.18 15.72 5.56 16 6 16L7 16C7.55 16 8 15.55 8 15L8 10.61L14.55 13.89C14.86 14.04 15.23 14.03 15.52 13.85C15.82 13.66 16 13.34 16 13L16 1Z",
    fill: "#194DFF",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrumpet);
export default __webpack_public_path__ + "static/media/trumpet.7cadcb49926003f5c32aad112c028a71.svg";
export { ForwardRef as ReactComponent };